<template>
	<div class="no-data-wrap">
		<!-- 删除提示 -->
		<div class="tips-del" style="margin-bottom: 0.5rem">
			<van-icon name="info-o" size="20" color="#EB3535" class="info-icon" />
			<span>选中相应商品后左滑然后点击删除即可完成删除操作!</span>
		</div>

		<!-- 搜索框 -->
		<SearchFake />

		<!-- 空状态图片 -->
		<img class="empty-image" src="/staticSeo/images/buyCar/car.png" alt="购物车为空" />

		<!-- 提示文字 -->
		<div class="tips-text">您的购物车还没有商品，快去选择商品吧</div>

		<!-- 去选购按钮 -->
		<van-button type="primary" class="go-shop-btn" @click="toBuy">去选购</van-button>
	</div>
</template>

<script setup>
import SearchFake from '@/components/SearchFake.vue';

// 跳转到主站分类页（与 FooterBar 分类 Tab 一致）
const toBuy = () => {
	navigateTo('/c');
};
</script>

<style scoped lang="scss">
.no-data-wrap {
	padding-top: 6px;
	height: calc(100vh - 42px);
	background: #fff;
	text-align: center;
}

.tips-del {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin: 0.5rem 0 0 0;
	padding: 0.3rem 1rem;
	background: #ffe7c3;
	color: #eb3535;
	font-size: 14px;

	.info-icon {
		font-weight: 900;
		position: relative;
		top: 1px;
	}
}

.empty-image {
	padding-top: 25px;
	margin: 0 auto 10px;
	width: 70%;
	object-fit: contain;
}

.tips-text {
	display: block;
	line-height: 40px;
	font-size: 19px;
	text-align: center;
	color: #333;
}

.go-shop-btn {
	width: 170px;
	height: 33px;
	line-height: 33px;
	font-size: 19px;
	background: #46539d;
	border: none;
	margin: 20px auto;
}

:deep(.search-box) {
	margin: 0 7.5px;
}
</style>
